const TIMEZONE_OFFSET = 60_000;

export const dateToISO8601String = (date: Date): string => {
  return new Date(date.getTime() - date.getTimezoneOffset() * TIMEZONE_OFFSET).toISOString();
};
